import React from 'react';
import Header from '../components/header';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Layout from '../components/layout';
import { useUserSelector } from '../store/selectors/userSelector';
import cashImg from '../images/attachment-1.jpeg';

const checklistItems = [
    'Biosecurity',
    'Walkthroughs',
    'Equipment checks',
    'Work requests',
    'Tasks',
    'Observations',
    'Activities',
];

const Home: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loggedinuser: any = useUserSelector();
    const firstName = loggedinuser?.firstName || 'there';

    return (
        <Layout>
            <Header title='Home'>
                <Header.Right />
            </Header>
            <div className='flex-grow overflow-auto flex items-center justify-center p-8'>
                <div className='bg-white rounded-2xl shadow-lg overflow-hidden w-full max-w-[42rem]'>
                    {/* Green header strip */}
                    <div className='bg-[#2B5A2E] px-7 py-3.5 flex items-center gap-2.5'>
                        <svg className='w-5 h-5 text-white opacity-80' fill='currentColor' viewBox='0 0 24 24'>
                            <path d='M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2a1.5 1.5 0 0 0-1.5 1.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'/>
                        </svg>
                        <span className='text-white text-sm font-semibold tracking-widest uppercase'>Pre-Flight Check</span>
                    </div>

                    {/* Body */}
                    <div className='flex gap-6 px-7 pt-7 pb-5'>
                        {/* Cash avatar */}
                        <div className='flex-shrink-0'>
                            <div className='w-[11rem] h-[11rem] rounded-xl overflow-hidden border-2 border-[#2B5A2E]/20 shadow-sm'>
                                <img src={cashImg} alt='Cash the Wingman' className='w-full h-full object-cover object-top' />
                            </div>
                        </div>

                        {/* Greeting */}
                        <div className='flex flex-col justify-between min-w-0'>
                            <div>
                                <p className='text-[#2B5A2E] font-bold text-xl leading-snug'>
                                    Hi {firstName} –
                                </p>
                                <p className='text-gray-700 text-base mt-1'>
                                    I'm <span className='font-semibold text-[#8D6E63]'>Cash</span>, your Wingman.
                                </p>
                                <p className='text-gray-500 text-sm mt-1'>Pleasure to fly with you today.</p>
                            </div>
                            <p className='text-gray-600 text-sm font-medium mt-4'>Here is your pre-flight check:</p>
                        </div>
                    </div>

                    {/* Checklist */}
                    <div className='px-7 pb-6'>
                        <ul className='grid grid-cols-2 gap-x-6 gap-y-2'>
                            {checklistItems.map(item => (
                                <li key={item} className='flex items-center gap-2 text-sm text-gray-700'>
                                    <span className='w-4 h-4 flex-shrink-0 rounded-full bg-[#2B5A2E]/10 flex items-center justify-center'>
                                        <svg className='w-2.5 h-2.5 text-[#2B5A2E]' fill='none' stroke='currentColor' strokeWidth={3} viewBox='0 0 12 12'>
                                            <path strokeLinecap='round' strokeLinejoin='round' d='M2 6l3 3 5-5'/>
                                        </svg>
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Footer */}
                    <div className='bg-[#2B5A2E]/5 border-t border-[#2B5A2E]/10 px-7 py-4 flex items-center justify-between'>
                        <span className='text-sm text-gray-500 italic'>Ready for takeoff.</span>
                        {/* <button
                            onClick={() => navigate('/my-dashboard')}
                            className='bg-[#2B5A2E] hover:bg-[#2D6A32] text-white text-sm font-semibold px-5 py-2 rounded-lg transition-colors flex items-center gap-2'
                        >
                            Let's go!
                            <svg className='w-4 h-4' fill='none' stroke='currentColor' strokeWidth={2.5} viewBox='0 0 16 16'>
                                <path strokeLinecap='round' strokeLinejoin='round' d='M3 8h10M9 4l4 4-4 4'/>
                            </svg>
                        </button> */}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default Home;